<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
     <div class="d-flex justify-content-between">
       <div class="text-right m-4">
         <h5 style="font-size: 1vw !important"> تعیین ماموریت/ {{$route.params.title}}</h5>
       </div>
       <div class="d-flex" v-if="allItems.length">
         <a :href="`${this.download_url}/Determining_Mission/all/word/by/id/${id_route}`"  style="margin-top: 1.3vw;" class="btn btn-primary btn-submit-1">خروجی Word</a>
         <a :href="`${this.download_url}/Determining_Mission/all/pdf/by/id/${id_route}`"  style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی PDF</a>
         <a    style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; " class="btn btn-primary btn-submit-1 "
               :style="!status_show ? 'background-color: red; border-color: red' : 'background-color: green; border-color: green'"
               @click="acceptComplete"
         >
           <div v-if="!status_loading">

             <span v-if="!status_show">  تایید وضعیت</span>
             <span v-else>عدم تایید</span>
           </div>
           <div v-else>
             <div class="loader-line"></div>

           </div>
         </a>
       </div>

     </div>




      <div class="table-responsive p-5">
        <center v-show="!allItems.length">
          ماموریت وجود ندارد
        </center>
        <table class="table table-striped" v-show="allItems.length">
          <tbody>
          <tr>
            <th rowspan="2"><strong>ردیف</strong></th>
            <th rowspan="2"><strong>
              محور مأموریتی
            </strong></th>

            <th rowspan="2"><strong>عنوان سند بالادستی </strong></th>
            <th rowspan="2"><strong> محدوده ISIC
              (اختیاری)
            </strong></th>
            <th rowspan="2"><strong>مدل نقش آفرینی</strong></th>
            <th colspan="3"><strong> زنجیره نتایج خدمت </strong></th>

            <th colspan="2"><strong>

              خدمت متناظر</strong></th>
          </tr>
          <tr>
            <th>خروجی</th>

            <th>پیامد</th>
            <th>نماگر</th>
            <th>کلان خدمت</th>
            <th> زیرخدمت (اختیاری)</th>


          </tr>
          <tr v-for="(item, index) in allItems">
            <td>{{index+1}}</td>
            <td>{{item.axis}}</td>
            <td>{{item.title}}</td>
            <td>{{item.range}}</td>
            <td>{{item.model}}</td>
            <td>{{item.definition_of_outputs.title}}</td>
            <td >
              <span style="cursor: pointer; color: blue !important" @click="showItems(item.id)" >مشاهده</span>
            </td>
            <td >
              <span style="cursor: pointer; color: blue !important" @click="showItemsNama(item.id)" >مشاهده</span>
            </td>
            <td>{{item.processes && item.processes.title}}</td>
            <td>{{item.sub_processes && item.sub_processes.title ? item.sub_processes.title : '--'}}</td>

          </tr>


          </tbody>
        </table>
      </div>

    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allItemsModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>پیامد ها    </p>
      <p @click="allItemsModal=!allItemsModal">❌</p>
    </div>
    <table v-if="allItemsList.length" class="table table-striped">
      <thead>
      <tr>
        <th>ردیف  </th>
        <th>پیامد  </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in allItemsList" :key="item.id">
        <td>{{index+1}}</td>
        <td>{{ item['title'] }}</td>
      </tr>

      </tbody>
    </table>
    <center class="bg-white" style="border-radius: 1vw" v-else>
      موردی یافت نشد
    </center>

  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allItemsModalNama"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>نماگر ها    </p>
      <p @click="allItemsModalNama=!allItemsModalNama">❌</p>
    </div>
    <table v-if="allItemsListNama.length" class="table table-striped">
      <thead>
      <tr>
        <th>ردیف  </th>
        <th>نماگر  </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in allItemsListNama" :key="item.id">
        <td>{{index+1}}</td>
        <td>{{ item['measurement_chart'] }}</td>
      </tr>

      </tbody>
    </table>
    <center class="bg-white" style="border-radius: 1vw" v-else>
      موردی یافت نشد
    </center>

  </div>

</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
  components: {
    Sidebar,
    splash,
    vSelect
  },
  data() {
    return {
      allItems: [],
      ListExits: [],
      ListProcess: [],
      ListParents: [],
      selectExit: '',
      ListConsequences: [],
      selectConsequences: '',
      selectProcess: '',
      selectParent: '',
      axis: '',
      title: '',
      range: '',
      model: '',
      id_route: this.$route['params']['id'],
      allItemsModal: false,
      allItemsModalNama: false,
      allItemsList: [],
      allItemsListNama: [],
      status_show: false,
      status_loading: false,

    }
  },
  methods: {
    acceptComplete(){
      if (this.status_loading){
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.allItem()
            }

          })
          .catch();
    },
    showItemsNama(id){
      this.allItemsListNama.length=0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all_items/effect/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            response.items.forEach((item)=>{
              this.allItemsListNama.push(item)
            })
            this.allItemsModalNama=true
          })
          .catch();
    },
    showItems(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all_items/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            response.items.forEach((item)=>{
              this.allItemsList.push(item)
            })
            this.allItemsModal=true
          })
          .catch();
    },
    allExits() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_of_output/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.items) {
              this.ListExits.length = 0
              response.items.forEach((item) => {
                this.ListExits.push(item)
              })
            }
          })
          .catch();
    },
    giveAllConsequences() {
      if (this.selectExit.id) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/Determining_Mission/select_consequences/${this.selectExit.id}`, requestOptions)
            .then(response => response.json())
            .then(response => {
              if (response.items) {
                this.ListConsequences.length = 0
                this.ListProcess.length = 0
                this.ListParents.length = 0
                this.selectConsequences = response.items[0]


                response.items.forEach((item) => {
                  this.ListConsequences.push(item)
                })
                response.process.forEach((item) => {
                  this.ListProcess.push(item)
                })
                response.parent.forEach((item) => {
                  this.ListParents.push(item)
                })
                this.selectProcess = response.process[0]
                this.selectParent = response.parent[0]

              }
            })
            .catch();
      }

    },
    resetModel(){
      this.selectConsequences=''
      this.selectProcess=''
      this.selectParent=''
      this.selectExit=''
      this.axis=''
      this.title=''
      this.range=''
      this.model=''

    },
    store() {
      if (this.axis.length===0){
        toast.error(' محور ماموریتی اجباری است!')
        return;
      }
      else if (this.title.length===0){
        toast.error('عنوان سند بالادستی اجباری است!')
        return;
      }

      else if (this.model.length===0){
        toast.error('مدل نقش آفرینی اجباری است!')
        return;
      }
      else if (this.selectConsequences.length===0){
        toast.error('خروجی اجباری است!')
        return;
      }
      else if (this.selectProcess.length===0){
        toast.error('پیامد اجباری است!')
        return;
      }
      else if (this.selectParent.length===0){
        toast.error('کلان خدمت اجباری است!')
        return;
      }
      else if (this.selectExit.length===0){
        toast.error('زیر خدمت اجباری است!')
        return;
      }

       var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('definition_of_outputs_id', this.selectExit.id)
      if (this.selectConsequences.type) {
        formdata.append('immediate_consequences_id', this.selectConsequences.id)
      }  if (!this.selectConsequences.type) {
        formdata.append('intermediate_outcomes_id', this.selectConsequences.id)
      }

      formdata.append('processes_id', this.selectProcess.id)
      formdata.append('sub_processes_id', this.selectParent.id)
      formdata.append('axis', this.axis)
      formdata.append('title', this.title)
      formdata.append('range', this.range)
      formdata.append('model', this.model)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              return
            }
             toast.success('عملیات با موفقیت انجام شد!')
            this.resetModel()
            this.allItem()
          })
          .catch();
    },
    allItem(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length=0
            response.all.forEach((item)=>{
              this.allItems.push(item)

            })
          })
          .catch();
    },
  },

  mounted() {
    this.allExits()
    this.allItem()
  },

  watch: {
    selectExit(newValue, oldValue) {
      this.giveAllConsequences()
    },
  }
}
</script>
<style scoped lang="scss">
label {
  font-size: 0.8vw;
}
</style>